var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"groupOptions":{
    enabled: true
  },"sort-options":{
    enabled: false
  },"styleClass":"vgt-table bordered condensed striped"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'group_name')?_c('span',[_c('a',{attrs:{"href":_vm.proposal_link(props.row.proposal_id)}},[_vm._v(_vm._s(props.row.group_name))])]):_c('span',[_vm._v("\n      "+_vm._s(props.formattedRow[props.column.field])+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }